import { createBrowserHistory } from 'history'
import ReactGA from 'react-ga';
import { trackPageView } from '../tracking';

export const history = createBrowserHistory();
history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
    trackPageView(location.pathname)   
  });


// WEBPACK FOOTER //
// ./src/shared/helpers/_history.js